<template>
    <v-select
            v-model="innerModel"
            :items="items"
            :item-value="itemValue"
            :item-text="itemText"
            :label="label"
            multiple
            clearable
            outlined
            dense
            :disabled="disabled"
            @blur="onBlur"
            @click:clear="onClearCliked"
            hide-details
    >
        <template v-slot:selection="{ item, index }">
            <span
                    v-if="index === 0"
                    class="text-truncate item-title">{{ item[itemText] }}</span>
            <span
                    v-if="index === 1"
                    class="grey--text subject-1"
            >+{{ innerModel.length - 1 }}</span>
        </template>
    </v-select>
</template>

<script>
    export default {
        name: "SearchMultiSelectBox",
        props: {
            value: {
                type: Array,
                default: () => [],
                required: false
            },
            items: Array,
            label: {
                type: String,
                default: "Select Items",
            },
            itemValue: {
                type: String,
                default: "codeKey"
            },
            itemText: {
                type: String,
                default: "codeValue"
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                innerModel: [],
                mark: [],
                isClearClicked: false,
            }
        },
        watch: {
            innerModel(newValue, oldValue) {
                // clear 버튼 클릭시 호출
                if (this.checkClearable(newValue)) {
                    this.emitEvent(newValue);
                }
            },
            value: {
                immediate: true,
                deep: true,
                handler: function (newValue, oldValue) {
                    this.innerModel = newValue;
                }
            },
        },
        methods: {
            onBlur() {
                if (this.checkDirty(this.innerModel, this.mark) !== true) return;
                this.emitEvent(this.innerModel);
            },
            emitEvent(newValue) {
                this.$emit('input', newValue);
                this.$emit('update:selected', newValue);
                this.mark = newValue;
            },
            checkDirty(newValue, oldValue) {
                return newValue !== oldValue;
            },
            onClearCliked() {
                this.isClearClicked = true;
                this.innerModel = [];
            },
            checkClearable(newValue) {
                if (!this.isClearClicked) return false;
                this.isClearClicked = false;
                return true;
            }
        }
    }
</script>

<style scoped>
    >>> input:read-only, >>> input {
        background-color: transparent !important;
        border: 0 !important;
    }

.item-title {
  max-width: calc(100% - 35px);
}
</style>
